import { gql } from '@apollo/client'

export const HELP_CENTER = gql`
  query HelpCenter {
    helpCenter {
      id
      createdAt
      updatedAt
      name
      description
      articles {
        id
        parentId
        createdAt
        updatedAt
        title
        description
        body
        state
      }
    }
  }
`
